





















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageDetail } from '@/modules/message';
import { AttachmentFile } from '@/models/attachmentFile';
import { Person } from '@/models/person';
import { PublicTypes } from '@/enums/publicTypes';
import { ReturnTypes } from '@/enums/returnTypes';
import { ElForm } from 'element-ui/types/form';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component
export default class MessageEdit extends AvaivaledVue {
  private PublicTypes = PublicTypes;
  private ReturnTypes = ReturnTypes;

  @Prop() private messageId: string;

  private customToolbar = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered'}, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1'}, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link']
  ];
  private isEdit = false;
  private isEditSendDate = true;
  private isEditReply = true;
  private isEditRelease = true;
  private previewVisible = false;
  private studentSelectVisible = false;

  private sendDate: Date | null = null;
  private sendTime: Date | null = null;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  private formRule = {
    sendDate: [
      { required: true, message: '配信日時を入力してください' },
      { validator: this.validateSendDate, trigger: 'blur' },
    ],
    title: [
      { required: true, message: 'タイトルを入力してください' },
    ],
    note: [
      { required: true, message: '内容を入力してください' },
      { validator: this.validateBody, trigger: 'blur' },
    ],
    studentList: [
      { required: true, message: '配信先を選択してください' },
      { validator: this.validateStudentList, trigger: 'blur' },
    ],
  };

  private validateSendDate(rule: any, value: string, callback: any) {
    if (!this.sendDate || !this.sendTime) {
      callback(new Error('配信日時を入力してください'));
    } else {
      callback();
    }
  }

  private validateBody(rule: any, value: string, callback: any) {
    if (value === '') {
      callback(new Error('内容を入力してください'));
    } else {
      callback();
    }
  }

  private validateStudentList(rule: any, value: string, callback: any, source: any) {
    const studentList = source.studentList as Person[];
    if (studentList.length === 0) {
      callback(new Error('配信先を選択してください'));
    } else {
      callback();
    }
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get message(): MessageDetail {
    return this.$store.state.message.selectedMessage;
  }

  get attachments(): AttachmentFile[] {
    if (!this.message) {
      return [];
    } else {
      return this.message.attachmentList.filter((file) => !file.isDelete);
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Message);
  }

  private async loadData() {
    const page = String(this.$route.name);
    const isEdit = (page.toUpperCase() === 'messageEdit'.toUpperCase());

    this.isEdit = isEdit;

    if (!!this.messageId) {
      try {
        await this.$store.dispatch('message/selectMessage', this.messageId);
      } catch (error) {
        //
      }

      if (!this.message) {
        this.$router.push({
          name: 'MessageList',
        });
        return;
      }

      if (this.message.sendDate) {
        this.sendDate = new Date(this.message.sendDate.getTime());
        this.sendTime = new Date(this.message.sendDate.getTime());
      } else {
        this.sendDate = null;
        this.sendTime = null;
      }

      if (isEdit) {
        this.isEditSendDate = this.message.sendDate as Date > new Date();
        this.isEditReply = !(this.message.publicType === PublicTypes.Public
                            && this.message.returnType === ReturnTypes.Enable);
        this.isEditRelease = !(this.message.publicType === PublicTypes.Public);
      }
    } else {
      this.$store.commit('message/initSelectedMessage');
    }
    this.$nextTick(() => {
      (this.$refs.form as ElForm).clearValidate();
    });
  }

  private onChangeSendDateTime() {
    if (!this.sendDate || !this.sendTime) {
      this.message.sendDate = null;
    } else {
      this.message.sendDate = new Date(
        this.sendDate.getFullYear(),
        this.sendDate.getMonth(),
        this.sendDate.getDate(),
        this.sendTime.getHours(),
        this.sendTime.getMinutes(),
      );
    }

    (this.$refs.form as any).validateField('sendDate');
  }

  private onClickSendDateTimeNow() {
    const now = new Date();
    this.sendDate = new Date(now.getTime());
    this.sendTime = new Date(now.getTime());

    this.onChangeSendDateTime();
  }

  private onSelectUploadFile(file: any) {
    this.message.attachmentList.push({
      url: null,
      name: file.name,
      localUrl: file.url,
      isDelete: false,
      raw: file.raw,
    });
  }

  private onRemoveUploadFile(file: AttachmentFile) {
    if (!file.url) {
      const index = this.message.attachmentList.findIndex((item) => {
        return item.localUrl === file.localUrl;
      });
      if (index >= 0) {
        this.message.attachmentList.splice(index, 1);
      }
    } else {
      const target = this.message.attachmentList.find((item) => {
        return item.url === file.url;
      });
      if (!!target) {
        target.isDelete = true;
      }
    }
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        this.onRegist();
      } else {
        return false;
      }
    });
  }

  private onRegist() {
    if (this.isEdit) {
      this.editMessage();
    } else {
      this.createMessage();
    }
  }

  private async createMessage() {
    let confirmText: string;
    if (this.message.publicType === PublicTypes.Private) {
        confirmText = '未公開のため配信されません。登録してよろしいですか？';
    } else {
      if (!this.message.sendDate || this.message.sendDate <= new Date()) {
        confirmText = '即座にメッセージを配信し、プッシュ通知を行います。登録してよろしいですか？';
      } else {
        const sendDateText = (this as any).$moment(this.message.sendDate).format('YYYY年MM月DD日 HH時mm分');
        confirmText = `${sendDateText} からメッセージを配信し、プッシュ通知を行います。登録してよろしいですか？`;
      }
    }
    try {
      await this.$confirm(confirmText, 'メッセージ登録', {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    await Promise.all(this.message.attachmentList.map(async (item) => {
      if (!item.isDelete && !!item.url && !item.raw) {
        try {
          item.raw  = await this.$store.dispatch('file/getFile', {
            url: item.url,
            name: item.name,
          });
        } catch (error) {
          return;
        }
      }
    }));

    try {
      for (const file of this.message.attachmentList) {
        if (file.isDelete) {
          continue;
        }
        await this.$store.dispatch('file/setAttachmentFileInfo', file);
      }

      await this.$store.dispatch('message/createMessage', {
        message: this.message,
        schoolId: this.schoolId,
      });

      await this.$store.dispatch(
        'message/searchMessages',
        this.$store.state.message.searchCondition
      );

      this.$router.push({ name: 'MessageList' });

      this.$notify({
        title: 'メッセージ登録完了',
        message: 'メッセージを登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'メッセージ登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async editMessage() {
    let confirmText: string;
    if (this.message.publicType === PublicTypes.Private) {
        confirmText = '未公開のため配信されません。変更してよろしいですか？';
    } else {
      if (!this.message.sendDate || this.message.sendDate <= new Date()) {
        confirmText = '即座にメッセージを配信し、プッシュ通知を行います。変更してよろしいですか？';
      } else {
        const sendDateText = (this as any).$moment(this.message.sendDate).format('YYYY年MM月DD日 HH時mm分');
        confirmText = `${sendDateText} からメッセージを配信し、プッシュ通知を行います。変更してよろしいですか？`;
      }
    }
    try {
      await this.$confirm(confirmText, 'メッセージ変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      const addFileList = this.message.attachmentList.filter((item) => {
        return !item.isDelete && item.url === null;
      }).map((item) => item.raw);

      const deleteFileIdList = this.message.attachmentList.filter((item) => {
        return item.isDelete && item.url !== null;
      }).map((item) => item.url as string);

      await this.$store.dispatch('message/editMessage', {
        message: this.message,
        schoolId: this.schoolId,
      });

      this.$router.push({ name: 'MessageList' });

      this.$notify({
        title: 'メッセージ変更完了',
        message: 'メッセージを変更しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'メッセージ変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private onCancel() {
    this.$router.push({ name: 'MessageList' });
  }
}
